import { Field, FormikErrors, FormikTouched } from 'formik';
import { Input } from '../Input';
import React from 'react';
import styles from './FormikInput.module.scss';

interface InputProps {
    label?: string
    name: string
    placeholder?: string
    errors?: FormikErrors<{
        [field: string]: any
    }>
    touched?: FormikTouched<{
        [field: string]: any
    }>
    autofocus?: boolean
    disabled?: boolean
    onChange: Function
    value?: any
}
export const FormikInput = ({name, errors, touched, placeholder, ...rest}: InputProps) => {
    // @ts-ignore
    const invalid = errors && errors[name] && errors[name].includes('valid');
    return (
        <div className={styles.wrapper}>
            {(errors && errors[name] && touched && touched[name]) ? (
                     invalid ?
                         <span className={styles.error}>{`${placeholder} format is incorrect`}</span>
                            : <span className={styles.error}>{`${placeholder} is required`}</span>
            ):null}
            <Field
                name={name}
                as={Input}
                type='text'
                placeholder={placeholder}
                {...rest}
            />
        </div>
    )
}
